import { Paragraph } from "@/components/ui/Typography";
import type { MicroSite } from "@/lib/api";

const SocialLinks = ({data}:{data: MicroSite}) => {


       

  const PreviewComponent = () => {
    return (
      <div className="flex relative w-full lg:py-4 gap-2  justify-end">   
          <div className="flex items-center gap-8" style={{color: data?.branding?.textColorCode}}>
          <div className="flex gap-8 flex-wrap">
            {data?.footerSection?.socialOne && <Paragraph>{data?.footerSection?.socialOne}</Paragraph>}

            {data?.footerSection?.socialTwo && <Paragraph>{data?.footerSection?.socialTwo}</Paragraph>}

            {data?.footerSection?.socialThree && <Paragraph>{data?.footerSection?.socialThree}</Paragraph>}
          </div>
          </div>
      
      </div>
    )
  };


  return (
    <div>
      <PreviewComponent />
    </div>
  )
}

export default SocialLinks